import { Button, Collapse, Group, Modal, Stack, Text } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useMatch } from 'react-router-dom';

export const DataFrozenTip = ({ close, visible }: { visible: boolean; close?: () => void }) => {
  const { t } = useTranslation();
  const [modalOpened, setModalOpened] = useState(false);

  const FrozenModal = () => {
    const match = useMatch('/datasets');
    const isDatasetPage = !!match;

    const closeModal = () => {
      setModalOpened(false);
    };

    return (
      <Modal
        opened={modalOpened}
        onClose={closeModal}
        title={<Text fw="bold">{t('dataset.frozen_title')}</Text>}
        size={'xl'}
        centered
      >
        <Stack>
          <Text>{t('dataset.frozen_text1')}</Text>
          <Text>{t('dataset.frozen_text2')}</Text>
          <Text fw="bold">{t('dataset.frozen_tip')}</Text>
          <Text>
            <Trans i18nKey={'dataset.frozen_step1'}>
              <span className="font-bold"></span>
            </Trans>
          </Text>
          <Text>
            <Trans i18nKey={'dataset.frozen_step2'}>
              <span className="font-bold"></span>
            </Trans>
          </Text>
          <Text>
            <Trans i18nKey={'dataset.frozen_step3'}>
              <span className="font-bold"></span>
            </Trans>
          </Text>
          <Text>
            <Trans i18nKey={'dataset.frozen_step4'}>
              <span className="font-bold"></span>
            </Trans>
          </Text>

          <div className="text-center mt-4">
            {isDatasetPage ? (
              <Button onClick={closeModal}>{t('dataset.frozen_modal_btn1')}</Button>
            ) : (
              <Button onClick={closeModal}>
                <a href="/datasets">{t('dataset.frozen_modal_btn2')}</a>
              </Button>
            )}
          </div>
        </Stack>
      </Modal>
    );
  };

  return (
    <>
      <Collapse in={visible}>
        <Group
          justify="space-between"
          className="flex items-center bg-yellow-200 py-3 px-5 rounded-md shadow-lg"
          mb={40}
          wrap="nowrap"
        >
          <Group className="truncate" wrap="nowrap">
            <IconInfoCircle className="flex-none" />
            <Text size="sm" className="text-dark-800 font-semibold truncate">
              {t('dataset.frozen_title')}: {t('dataset.frozen_text1')}
            </Text>
          </Group>
          <Group className="space-x-3" wrap="nowrap">
            <Button
              size="sm"
              className="bg-white text-dark-800 hover:bg-violet-500 hover:text-white font-bold rounded"
              onClick={() => {
                setModalOpened(true);
              }}
            >
              {t('dataset.frozen_detail_btn')}
            </Button>
            {/* <CloseButton aria-label="Close" className="text-violet-600 hover:text-violet-500" onClick={close} /> */}
          </Group>
        </Group>
      </Collapse>
      <FrozenModal />
    </>
  );
};
